module.exports = __webpack_public_path__ + "static/media/brown_circle.67504bc8.svg";